import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import { Link, useLocation } from "react-router-dom";

interface NavSecondaryItem {
  title: string;
  href: string;
  icon?: React.ReactNode;
  description?: string;
  customComponent?: React.ComponentType;
}

export function NavSecondary({
  title,
  items,
}: {
  title?: string;
  items: NavSecondaryItem[];
}) {
  const location = useLocation();

  return (
    <SidebarGroup>
      {title && <SidebarGroupLabel>{title}</SidebarGroupLabel>}
      <SidebarMenu>
        {items.map((item) => {
          if (item.customComponent) {
            const CustomComponent = item.customComponent;
            return <CustomComponent key={item.title} />;
          }

          const isActive = location.pathname === item.href;

          return (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild isActive={isActive} tooltip={item.title}>
                <Link
                  to={item.href}
                  className="flex items-center w-full p-2 rounded-md"
                >
                  {item.icon}
                  <span className="font-medium text-gray-700">{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
